import React from 'react'
import styled from 'styled-components'
import { colors } from '../../styles/constants'

const TagContainer = styled.div`
  background-color: ${colors.cyan.light};
  color: ${colors.cyan.default};
  width: fit-content;
  border-radius: 8px;
  padding: 6px 8px;
  font-weight: 600;
  font-family: 'Open Sans';
  font-size: 14px;
  line-height: 20px;
`
const Tag = ({ children }) => <TagContainer>{children}</TagContainer>

export default Tag
